import axios from 'axios'
import { useBlitzStore } from './stores/BlitzStore'

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  const status = error.response ? error.response.status : null
  const path = error.response ? error.response.config.url : null

  switch (status) {
    case 401:
      if (path.startsWith('/api/blitz') && path !== '/api/blitz/login') {
        const store = useBlitzStore()
        store.$reset()
        window.location.href = '/login'
      }
      break
    case 419:
      window.location.reload()
      break
  }

  return Promise.reject(error)
})

export default axios
